/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deals_Actual_ValueInputs */

const cs_deals_actual_value = /** @type {(inputs: Deals_Actual_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skutečná hodnota`)
};

const en_deals_actual_value = /** @type {(inputs: Deals_Actual_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actual value`)
};

/**
* | output |
* | --- |
* | "Actual value" |
*
* @param {Deals_Actual_ValueInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deals_actual_value = /** @type {((inputs?: Deals_Actual_ValueInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deals_Actual_ValueInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deals_actual_value(inputs)
	return cs_deals_actual_value(inputs)
});